import { createSlice } from '@reduxjs/toolkit';


let storedUserInfo = null;
try {
  const raw = localStorage.getItem('userInfo');
  if (raw) storedUserInfo = JSON.parse(raw);
} catch {
  localStorage.removeItem('userInfo');
}
const initialState = { userInfo: storedUserInfo };

const authApiSlice = createSlice({ 
  name: 'signIn',
  initialState,
  reducers: { 
    setCredentials: (state, action) => { 
      state.userInfo = action.payload;
      localStorage.setItem('userInfo', JSON.stringify(action.payload));
    },
    signOut: (state, action) => { 
      state.userInfo = null;
      localStorage.removeItem('userInfo');
    }
  },
});


export const { setCredentials, signOut } = authApiSlice.actions;
export default authApiSlice.reducer;